import React,{useState, useEffect} from 'react'
import {Table,Button,Nav} from 'react-bootstrap';
import axios from 'axios';
import {Redirect} from 'react-router-dom'
import {API_URL, PUBLIC_URL} from '../../config';
import LoadingPage from './LoadingPage';


import AddBoilderFuel from './AddBoilerFuel'

export default function BoilersComsumtionData() {

    const [boilersComsData, setboilersComsData] = useState(null);
    const [currentBoilersComsData, setcurrentBoilersComsData] = useState(null);
    const[loggedInUser,setLoggedInUser] = useState(null);
    const [redirecting,setRedirecting] = useState (false);
    const [shownConsumtionDetails, setshownConsumtionDetails] =  useState(false)

    let mes = ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Nombiembre','Diciembre']


    useEffect(()=>{
        axios.get(`${API_URL}/user`, {withCredentials: true})
        .then((result) => {
          setLoggedInUser(result.data)
          axios.get(`${API_URL}/boilers/cdata/all`, {withCredentials: true})
          .then((boilDataRes)=>{
            setboilersComsData(boilDataRes.data)
          })
          axios.get(`${API_URL}/boilers/currentcdata/all`, {withCredentials: true})
          .then((boilDataRes)=>{
            setcurrentBoilersComsData(boilDataRes.data[0])
          })
          
        }).catch(() => {
            setRedirecting(true)
        })
    },[])

    const AddLitersToDeposit = (liters)=>{
        axios.post(`${API_URL}/boilers/deposit/load/add`,{liters:liters}, {withCredentials: true})
        .then((boilDataRes)=>{
            console.log(boilDataRes)
            let now = new Date();
            let nowFixed = now.toISOString();
            let boilersComsDataClone = JSON.parse(JSON.stringify(boilersComsData));
            boilersComsDataClone.push({load:true, totalLoaded:Number(liters), fecha:nowFixed, boilersData:[]})
            setboilersComsData(boilersComsDataClone)

        })

    }

    const SwitchShownDetails = () => {
        if(shownConsumtionDetails)setshownConsumtionDetails(false)
        else setshownConsumtionDetails(true)
    }

let headStyle = {position:"sticky", top:0, zIndex:"2", backgroundColor:"lightgrey", verticalAlign:"middle"};
let headStyle2 = {position:"sticky", top:0, zIndex:"2", backgroundColor:"lightgrey", verticalAlign:"middle"};


  if(redirecting) return <Redirect to={'/signin'}/>
  if(!boilersComsData || !loggedInUser) return <LoadingPage/>
  let accDepósit = 0;
  let boilersDataReversed = [];
    let currentAccDepósit = 0;

//Calculamos el total consumido ahora
  let CurrenttotalDayComsumption = Number(currentBoilersComsData?currentBoilersComsData.boilersData[0].oilData.dayConsumption:0) + 
  Number(currentBoilersComsData?currentBoilersComsData.boilersData[1].oilData.dayConsumption:0) + 
  Number(currentBoilersComsData?currentBoilersComsData.boilersData[2].oilData.dayConsumption:0);

  boilersComsData.map((boildata, i)=>{
    let totalDayComsumption = Number(boildata.boilersData[0]?boildata.boilersData[0].oilData.dayConsumption:0) + 
    Number(boildata.boilersData[1]?boildata.boilersData[1].oilData.dayConsumption:0) + 
    Number(boildata.boilersData[2]?boildata.boilersData[2].oilData.dayConsumption:0);
    if(boildata.load) {
        accDepósit = accDepósit + boildata.totalLoaded;

    }
    else accDepósit = accDepósit - totalDayComsumption;
    if(accDepósit <0) accDepósit = 0;
    // if(accDepósit >4700) accDepósit = 6000;
    //console.log(boilersDataReversed)
    boilersDataReversed.push({accDepósit:accDepósit,totalDayComsumption:totalDayComsumption,...boildata})
    if(i==boilersComsData.length-1) {currentAccDepósit =  accDepósit - CurrenttotalDayComsumption}
})

let CurrentdepStatusStyle = {width:"12%", fontWeight:"900"}

if((currentAccDepósit <3000 && currentAccDepósit >=2000)) CurrentdepStatusStyle = {color:"orange", ...CurrentdepStatusStyle}
if(currentAccDepósit <2000) CurrentdepStatusStyle = {color:"red", ...CurrentdepStatusStyle}
if(currentAccDepósit >=3000) CurrentdepStatusStyle = {color:"green", ...CurrentdepStatusStyle}


  let reversedboilersComsData = [...boilersDataReversed].reverse()

  return (
    <div style={{margin:"10px", maxWidth:"100%", overflow:"auto", maxHeight:"750px"}}>
        <Table striped bordered hover id="boilersConmsumtionTable">
            <thead style={{textAlign:"center", verticalAlign:"middle"}}>
                <th className='headcol' style={headStyle2}>Día</th>
                {
                    shownConsumtionDetails?(<>
                        <th style={headStyle}>Consumo Caldera AT 1 (Grande)(L)</th>
                        <th style={headStyle}>Consumo Caldera AT 2 (L)</th>
                        <th style={headStyle}>Consumo Caldera VAPOR (L)</th>
                    </>
                    ):""
                }
                <th style={headStyle}>Total Consumo (L) <br/><Button className='boxShadowS' variant='secondary' onClick={()=>SwitchShownDetails()}>{shownConsumtionDetails?"-":"+"}</Button></th>
                <th style={headStyle}>Aporte (L) <br/> <AddBoilderFuel AddLitersToDeposit = {AddLitersToDeposit}/></th>
                <th style={headStyle}>Estado depósito (L) <br/> (500 - 5000)</th>
            </thead>
            <tbody>
            <tr style={{textAlign:"center"}}>
            <td className='headcol'  style={{width:"18%"}}>HOY - {currentBoilersComsData?currentBoilersComsData.fecha.slice(11,16):""} h</td>
            {
                shownConsumtionDetails?(<>

                <td style={{width:"12%"}}>-{currentBoilersComsData?(Number(currentBoilersComsData.boilersData[0].oilData.dayConsumption).toFixed(2)):"-"}</td>
                <td style={{width:"12%"}}>-{currentBoilersComsData?(Number(currentBoilersComsData.boilersData[1].oilData.dayConsumption).toFixed(2)):"-"}</td>
                <td style={{width:"12%"}}>-{currentBoilersComsData?(Number(currentBoilersComsData.boilersData[2].oilData.dayConsumption).toFixed(2)):"-"}</td>
                </>
                ):""
            }
                <td style={{width:"12%"}}>-{Number(CurrenttotalDayComsumption).toFixed(2)}</td>
                <td style={{width:"12%"}}>-</td>
                <td style={CurrentdepStatusStyle}>{Number(currentAccDepósit).toFixed(2)}</td>
            </tr>
            {
                reversedboilersComsData.map((boildata, i)=>{
                    let depStatusStyle = {width:"12%", fontWeight:"600"}
                    let rowStyle = {
                        textAlign:"center"
                    }
                    let numMes = Number(boildata.fecha.slice(5,7))
                    let elmes = mes[numMes-1];
                    if(boildata.load) {
                        rowStyle = {
                            textAlign:"center",
                            backgroundColor: "rgba(50, 168, 82, 0.2)"
                        }
                    }
                    if((boildata.accDepósit <3000 && boildata.accDepósit >=2000)) depStatusStyle = {...depStatusStyle, color:"orange"}
                    if(boildata.accDepósit <2000) depStatusStyle = {...depStatusStyle, color:"red"}
                    if(boildata.accDepósit >=3000) depStatusStyle = {...depStatusStyle, color:"green"}
                    {/* if(i == 0) depStatusStyle = {fontWeight:"900", ...depStatusStyle} */}
                    return(
                        <tr style={rowStyle}>
                            <td className='headcol'  style={{width:"18%"}}>{boildata.fecha.slice(8,10)  +" "+ elmes +" "+ boildata.fecha.slice(0,4 )}</td>
                            {
                                shownConsumtionDetails?(<>
                                <td style={{width:"13%"}}>-{boildata.boilersData[0]?(Number(boildata.boilersData[0].oilData.dayConsumption).toFixed(2)):"-"}</td>
                                <td style={{width:"13%"}}>-{boildata.boilersData[1]?(Number(boildata.boilersData[1].oilData.dayConsumption).toFixed(2)):"-"}</td>
                                <td style={{width:"13%"}}>-{boildata.boilersData[2]?(Number(boildata.boilersData[2].oilData.dayConsumption).toFixed(2)):"-"}</td>
                                </>
                                ):""
                            }
                            <td style={{width:"14%"}}>-{Number(boildata.totalDayComsumption).toFixed(2)}</td>
                            <td style={{width:"13%"}}>{boildata.load?("+" + boildata.totalLoaded):"-"}</td>
                            <td style={depStatusStyle}>{Number(boildata.accDepósit).toFixed(2)}</td>
                        </tr>
                    )
                })
            }
            </tbody>
        </Table>
    </div>
  )
}
